import { styled } from 'styled-components';

interface ICardWithLeftStrokeProps {
  color?: string;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (min-width: 991px) {
    flex-direction: row;
  }
`;

export const MainContent = styled.div`
  flex: 1;
`;

export const AdContent = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.primary.color};
  max-height: 11.6875rem;
  padding: 7vh 5vw;

  .mobile-image {
    position: absolute;
    bottom: 0;
  }

  @media (max-width: 991px) {
    .desktop-image {
      display: none;
    }

    padding: 0;
  }

  @media (min-width: 991px) {
    background-color: ${({ theme }) => theme.colors.border};
    justify-content: center;

    max-height: 100%;
    .mobile-image {
      display: none;
    }
  }
`;

export const DesktopADContent = styled.div<{ url: string }>`
  display: none;

  @media (min-width: 991px) {
    display: block;
    background: ${({ url }) => `url(${url}) no-repeat center/cover`};
    width: 360px;
    max-width: 360px;
    border-radius: 10px;
    height: 100%;
    max-height: 34rem;
  }
`;

export const MobileADContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  width: 100%;

  img {
    position: absolute;
  }

  p,
  button {
    width: 12rem;
  }

  @media (min-width: 991px) {
    display: none;
  }
`;

export const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: 800;
  line-height: 1.1;
`;

export const CardWithLeftStroke = styled.div<ICardWithLeftStrokeProps>`
  border: none;

  @media (min-width: 991px) {
    border-left: ${({ color, theme }) => `3px solid ${color || theme.colors.texts_light}`};
    padding-left: 1.87rem;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const ButtonsStore = styled.button`
  padding: 0;
`;
